module.exports = __webpack_public_path__ + "img/AFMS_MB_CN.1595e0d7.png";